package navigation.settings.areas.addeditarea

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.area.domain.usecase.AddEditAreaUseCase
import com.essntl.features.area.ui.addeditarea.AddEditAreaEvent
import com.essntl.features.area.ui.addeditarea.AddEditAreaState
import com.essntl.features.area.ui.addeditarea.AddEditAreaValidation
import com.essntl.features.area.ui.addeditarea.AddEditAreaViewModel
import com.essntl.features.country.domain.repository.CountryRepository
import com.essntl.features.proposal.domain.repository.ProposalRepository
import com.essntl.features.supplier.domain.repository.SupplierRepository
import com.essntl.toastmanager.ToastManager

class AddEditAreaScreenModel(
    countryRepository: CountryRepository,
    areaRepository: AreaRepository,
    proposalRepository: ProposalRepository,
    supplierRepository: SupplierRepository,
    addEditAreaUseCase: AddEditAreaUseCase,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<AddEditAreaState>(AddEditAreaState()) {

    val validation = AddEditAreaValidation()

    private val viewModel =
        AddEditAreaViewModel(
            countryRepository = countryRepository,
            areaRepository = areaRepository,
            proposalRepository = proposalRepository,
            supplierRepository = supplierRepository,
            addEditAreaUseCase = addEditAreaUseCase,
            loadingManager = loadingManager,
            toastManager = toastManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: AddEditAreaEvent) = viewModel.onEvent(event)
}